/**
 * Mikolito — Comments Widget
 * Wgraj do Shopify: Assets → comments-widget.js
 */
(function () {
  'use strict';

  const CONFIG         = window.MikolitoComments || {};
  const API_URL        = CONFIG.apiUrl        || 'https://aleksandrabrykowicz.pl/comments/comments.php';
  const ARTICLE_HANDLE = CONFIG.articleHandle || 'unknown';

  // ─── Stan ───
  let state = {
    comments:    [],
    total:       0,
    loading:     true,
    submitting:  false,
    replyingTo:  null,   // ID komentarza, na który odpowiadamy
    error:       null,
    submitMsg:   null,
  };

  // ─── Init ───
  function init() {
    const containers = document.querySelectorAll('[data-comments-widget]');
    if (!containers.length) return;
    containers.forEach(c => render(c));
    fetchComments();
  }

  // ─── Fetch ───
  async function fetchComments() {
    try {
      const res  = await fetch(`${API_URL}?article=${encodeURIComponent(ARTICLE_HANDLE)}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      state.comments = data.comments || [];
      state.total    = data.total    || 0;
      state.error    = null;
    } catch (e) {
      state.error = 'Nie udało się załadować komentarzy.';
    } finally {
      state.loading = false;
      rerender();
    }
  }

  // ─── Submit ───
  async function submitComment(formEl, parentId) {
    const name    = formEl.querySelector('[data-field="name"]').value.trim();
    const email   = formEl.querySelector('[data-field="email"]').value.trim();
    const content = formEl.querySelector('[data-field="content"]').value.trim();

    if (!name || !content) {
      showFormError(formEl, 'Wypełnij imię i treść komentarza.');
      return;
    }

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showFormError(formEl, 'Nieprawidłowy adres e-mail.');
      return;
    }

    state.submitting = true;
    rerender();

    try {
      const res = await fetch(API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          article:   ARTICLE_HANDLE,
          name,
          email,
          content,
          parent_id: parentId || null,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        const msg = data.errors ? data.errors.join(' ') : (data.error || 'Wystąpił błąd.');
        state.submitting = false;
        rerender();
        // przywróć formularz z błędem
        setTimeout(() => {
          const form = document.querySelector(parentId ? `[data-reply-form="${parentId}"]` : '[data-main-form]');
          if (form) showFormError(form, msg);
        }, 50);
        return;
      }

      state.submitMsg  = data.message;
      state.submitting = false;
      state.replyingTo = null;
      rerender();

      // Ukryj komunikat po 6 sekundach
      setTimeout(() => { state.submitMsg = null; rerender(); }, 6000);

    } catch (e) {
      state.submitting = false;
      rerender();
    }
  }

  // ─── Render ───
  function render(container) {
    container.innerHTML = buildHTML();
    attachEvents(container);
  }

  function rerender() {
    document.querySelectorAll('[data-comments-widget]').forEach(c => render(c));
  }

  function buildHTML() {
    const count = state.total;

    return `
      <div class="cmw">
        <div class="cmw-header">
          <h2 class="cmw-title">
            💬 Komentarze
            ${count > 0 ? `<span class="cmw-count">${count}</span>` : ''}
          </h2>
        </div>

        ${state.submitMsg ? `
          <div class="cmw-success">
            🧡 ${escHtml(state.submitMsg)}
          </div>` : ''}

        ${state.loading ? `
          <div class="cmw-loading">Ładowanie komentarzy…</div>` : ''}

        ${state.error ? `
          <div class="cmw-error">${escHtml(state.error)}</div>` : ''}

        ${!state.loading && state.comments.length === 0 && !state.error ? `
          <div class="cmw-empty">
            <span class="cmw-empty-icon">🌊</span>
            Bądź pierwszy! Napisz, co dziecko myśli o tej bajce.
          </div>` : ''}

        ${state.comments.map(c => buildCommentHTML(c)).join('')}

        <div class="cmw-form-wrap" data-main-form>
          <h3 class="cmw-form-title">Dodaj komentarz</h3>
          ${buildFormHTML(null)}
        </div>
      </div>`;
  }

  function buildCommentHTML(c) {
    const isReplying = state.replyingTo === c.id;
    const repliesHTML = (c.replies || []).map(r => `
      <div class="cmw-reply">
        <div class="cmw-comment-meta">
          <span class="cmw-avatar cmw-avatar--small">${avatarLetter(r.author_name)}</span>
          <strong class="cmw-author">${escHtml(r.author_name)}</strong>
          <span class="cmw-date">${formatDate(r.created_at)}</span>
        </div>
        <div class="cmw-content">${escHtml(r.content)}</div>
      </div>`).join('');

    return `
      <div class="cmw-comment" id="comment-${c.id}">
        <div class="cmw-comment-meta">
          <span class="cmw-avatar">${avatarLetter(c.author_name)}</span>
          <strong class="cmw-author">${escHtml(c.author_name)}</strong>
          <span class="cmw-date">${formatDate(c.created_at)}</span>
        </div>
        <div class="cmw-content">${escHtml(c.content)}</div>

        <button class="cmw-reply-toggle" data-reply-to="${c.id}">
          ${isReplying ? '✕ Anuluj' : '↩ Odpowiedz'}
        </button>

        ${repliesHTML}

        ${isReplying ? `
          <div class="cmw-reply-form" data-reply-form="${c.id}">
            <div class="cmw-form-title cmw-form-title--reply">
              Odpowiadasz na komentarz <strong>${escHtml(c.author_name)}</strong>
            </div>
            ${buildFormHTML(c.id)}
          </div>` : ''}
      </div>`;
  }

  function buildFormHTML(parentId) {
    const disabled = state.submitting ? 'disabled' : '';
    return `
      <div class="cmw-form" data-parent="${parentId || ''}">
        <div class="cmw-form-row">
          <input
            class="cmw-input"
            type="text"
            data-field="name"
            placeholder="Twoje imię *"
            maxlength="100"
            ${disabled}
          >
          <input
            class="cmw-input"
            type="email"
            data-field="email"
            placeholder="E-mail (opcjonalnie, nie będzie widoczny)"
            ${disabled}
          >
        </div>
        <textarea
          class="cmw-textarea"
          data-field="content"
          placeholder="Napisz komentarz… Co powiedziało dziecko? Która scena była ulubiona?"
          maxlength="2000"
          rows="3"
          ${disabled}
        ></textarea>
        <div class="cmw-form-footer">
          <span class="cmw-form-note">🔒 E-mail nie będzie widoczny publicznie</span>
          <button class="cmw-submit" data-submit="${parentId || ''}" ${disabled}>
            ${state.submitting ? 'Wysyłanie…' : 'Wyślij komentarz →'}
          </button>
        </div>
        <div class="cmw-form-error" style="display:none;"></div>
      </div>`;
  }

  // ─── Events ───
  function attachEvents(container) {
    // Toggle odpowiedzi
    container.querySelectorAll('[data-reply-to]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.replyTo);
        state.replyingTo = state.replyingTo === id ? null : id;
        rerender();
        // Scroll do formularza
        setTimeout(() => {
          const form = document.querySelector(`[data-reply-form="${id}"]`);
          if (form) form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 50);
      });
    });

    // Submit
    container.querySelectorAll('[data-submit]').forEach(btn => {
      btn.addEventListener('click', () => {
        const parentId = btn.dataset.submit ? parseInt(btn.dataset.submit) : null;
        const formEl   = btn.closest('.cmw-form');
        submitComment(formEl, parentId);
      });
    });
  }

  function showFormError(formEl, msg) {
    const errEl = formEl.querySelector('.cmw-form-error');
    if (errEl) {
      errEl.textContent = msg;
      errEl.style.display = 'block';
    }
  }

  // ─── Helpers ───
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function avatarLetter(name) {
    return (name || '?').charAt(0).toUpperCase();
  }

  function formatDate(dateStr) {
    const d = new Date(dateStr);
    return d.toLocaleDateString('pl-PL', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  // ─── Style ───
  function injectStyles() {
    if (document.getElementById('mikolito-cmw-styles')) return;
    const s = document.createElement('style');
    s.id = 'mikolito-cmw-styles';
    s.textContent = `
      .cmw { margin-top: 40px; font-family: var(--mik-font-body, 'Nunito', sans-serif); }

      .cmw-header { margin-bottom: 20px; }

      .cmw-title {
        font-family: var(--mik-font-display, 'Baloo 2', sans-serif);
        font-size: 1.15rem; font-weight: 800;
        color: var(--mik-ink, #2B2014); display: flex; align-items: center; gap: 10px;
        margin: 0; line-height: 1.1; letter-spacing: normal; text-transform: uppercase;
      }

      .cmw-count {
        background: var(--mik-navy, #131A33); color: #fff;
        font-size: 0.75rem; font-weight: 800;
        padding: 2px 9px; border-radius: 20px;
      }

      .cmw-success {
        background: #ECFDF5; border: 1.5px solid #6EE7B7;
        border-radius: 12px; padding: 14px 18px;
        font-size: 0.9rem; font-weight: 700; color: #065F46;
        margin-bottom: 20px;
      }

      .cmw-loading, .cmw-error {
        padding: 16px; font-size: 0.88rem;
        color: var(--mik-text-muted-2, #75664F); font-weight: 600;
      }

      .cmw-error { color: #DC2626; }

      .cmw-empty {
        padding: 28px 20px; text-align: center;
        border: 2px dashed var(--mik-cream-border, #EFDDB6); border-radius: 16px;
        font-size: 0.88rem; color: var(--mik-text-muted-2, #75664F); font-weight: 600;
        margin-bottom: 24px;
      }

      .cmw-empty-icon { display: block; font-size: 1.8rem; margin-bottom: 8px; }

      /* Komentarz */
      .cmw-comment {
        background: #fff; border: 1.5px solid var(--mik-cream-border, #EFDDB6);
        border-radius: 16px; padding: 20px 22px;
        margin-bottom: 14px;
      }

      .cmw-comment-meta {
        display: flex; align-items: center; gap: 10px;
        margin-bottom: 10px;
      }

      .cmw-avatar {
        width: 36px; height: 36px; border-radius: 50%;
        background: var(--mik-navy, #131A33); color: var(--mik-amber, #F59E0B);
        display: flex; align-items: center; justify-content: center;
        font-family: var(--mik-font-display, 'Baloo 2', sans-serif); font-size: 0.9rem; font-weight: 800;
        flex-shrink: 0;
      }

      .cmw-avatar--small {
        width: 28px; height: 28px; font-size: 0.75rem;
      }

      .cmw-author { font-size: 0.88rem; font-weight: 800; color: var(--mik-ink, #2B2014); }

      .cmw-date { font-size: 0.72rem; color: var(--mik-text-muted-2, #75664F); font-weight: 600; margin-left: auto; }

      .cmw-content {
        font-size: 0.92rem; line-height: 1.75;
        color: var(--mik-ink, #2B2014); font-weight: 600; white-space: pre-wrap;
        margin-bottom: 12px;
      }

      .cmw-reply-toggle {
        background: none; border: 1.5px solid var(--mik-cream-border, #EFDDB6);
        border-radius: 20px; padding: 5px 14px;
        font-family: var(--mik-font-body, 'Nunito', sans-serif); font-size: 0.78rem; font-weight: 800;
        color: var(--mik-text-muted-2, #75664F); cursor: pointer; transition: all 0.2s;
        margin-bottom: 14px;
      }

      .cmw-reply-toggle:hover { border-color: var(--mik-amber, #F59E0B); color: var(--mik-amber-dark, #D97706); }

      /* Odpowiedź */
      .cmw-reply {
        background: var(--mik-cream-paper, #FBF3E3); border-left: 3px solid var(--mik-amber, #F59E0B);
        border-radius: 0 12px 12px 0; padding: 14px 16px;
        margin-top: 10px; margin-left: 16px;
      }

      .cmw-reply .cmw-content { margin-bottom: 0; }

      /* Formularz odpowiedzi */
      .cmw-reply-form {
        margin-top: 14px; margin-left: 16px;
        background: var(--mik-cream-paper, #FBF3E3); border-radius: 12px; padding: 16px;
      }

      /* Formularz główny */
      .cmw-form-wrap {
        background: #fff; border: 1.5px solid var(--mik-cream-border, #EFDDB6);
        border-radius: 16px; padding: 22px;
        margin-top: 24px;
      }

      .cmw-form-title {
        font-family: var(--mik-font-display, 'Baloo 2', sans-serif);
        font-size: 1rem; font-weight: 800;
        color: var(--mik-ink, #2B2014); margin-bottom: 14px;
      }
      h3.cmw-form-title { margin: 0 0 14px; line-height: 1.1; letter-spacing: normal; text-transform: none; }

      .cmw-form-title--reply {
        font-size: 0.85rem; color: var(--mik-text-muted-2, #75664F); margin-bottom: 10px;
      }

      .cmw-form-row {
        display: grid; grid-template-columns: 1fr 1fr;
        gap: 10px; margin-bottom: 10px;
      }

      .cmw-input, .cmw-textarea {
        font-family: var(--mik-font-body, 'Nunito', sans-serif); font-size: 0.9rem; font-weight: 600;
        padding: 10px 14px; border: 1.5px solid var(--mik-cream-border, #EFDDB6);
        border-radius: 10px; background: var(--mik-cream-paper, #FBF3E3); color: var(--mik-ink, #2B2014);
        outline: none; transition: border-color 0.2s; width: 100%;
      }

      .cmw-input:focus, .cmw-textarea:focus { border-color: var(--mik-amber, #F59E0B); }
      .cmw-input::placeholder, .cmw-textarea::placeholder { color: var(--mik-text-muted-2, #75664F); }
      .cmw-textarea { resize: vertical; min-height: 80px; margin-bottom: 10px; }

      .cmw-form-footer {
        display: flex; align-items: center;
        justify-content: space-between; gap: 12px; flex-wrap: wrap;
      }

      .cmw-form-note { font-size: 0.72rem; color: #75664F; font-weight: 600; }

      .cmw-submit {
        background: var(--mik-navy, #131A33); color: #fff;
        font-family: var(--mik-font-body, 'Nunito', sans-serif); font-size: 0.88rem; font-weight: 800;
        padding: 10px 22px; border-radius: 30px; border: none;
        cursor: pointer; transition: all 0.2s; white-space: nowrap;
      }

      .cmw-submit:hover:not(:disabled) { background: var(--mik-amber, #F59E0B); color: var(--mik-navy, #131A33); }
      .cmw-submit:disabled { opacity: 0.6; cursor: not-allowed; }

      .cmw-form-error {
        margin-top: 8px; padding: 8px 12px;
        background: #FEF2F2; border-radius: 8px;
        font-size: 0.8rem; color: #DC2626; font-weight: 700;
      }

      @media (max-width: 560px) {
        .cmw-form-row { grid-template-columns: 1fr; }
        .cmw-form-footer { flex-direction: column; align-items: flex-start; }
        .cmw-submit { width: 100%; text-align: center; }
      }
    `;
    document.head.appendChild(s);
  }

  // ─── Start ───
  injectStyles();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
